import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";

import "./tourexclusion.scss";

function TourExclusionList() {
  const navigate = useNavigate();
  const [tourExclusions, setTourExclusions] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const breadcrumbItems = [
    { title: "Tour Exclusion", link: "#" },
    { title: "Tour Exclusion List", link: "#" },
  ];

  React.useEffect(() => {
    fetchTourExclusion();
  }, []);

  const fetchTourExclusion = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.API_BASE_URL}/tourexclusions`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Tour Exclusion data:', data);
      
      // Handle different response formats
      if (Array.isArray(data)) {
        setTourExclusions(data);
      } else if (data.data && Array.isArray(data.data)) {
        setTourExclusions(data.data);
      } else if (Array.isArray(data.tourExclusions)) {
        setTourExclusions(data.tourExclusions);
      } else {
        console.warn('Unexpected data format:', data);
        setTourExclusions([]); // Set to empty array if format is unexpected
      }
    } catch (error) {
      console.error('Error fetching tourexclusions:', error);
      setError(error.message);
      setTourExclusions([]); // Ensure it's always an array
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (tourexclusion) => {
    navigate(`/edit-tourexclusions/${tourexclusion._id}`, { state: { tourexclusion } });
  };

  const handleDelete = async (tourexclusionId) => {
    if (window.confirm("Are you sure you want to delete this tour exclusion?")) {
      try {
        const response = await fetch(`${config.API_BASE_URL}/tourexclusions/${tourexclusionId}`, {
          method: 'DELETE'
        });
        
        if (response.ok) {
          setTourExclusions(tourExclusions.filter(cat => cat._id !== tourexclusionId));
        } else {
          console.error('Failed to delete tour exclusion');
        }
      } catch (error) {
        console.error('Error deleting tour exclusion:', error);
      }
    }
  };

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center">Loading tour exclusions...</div>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center text-danger">Error: {error}</div>
        </Container>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Tour Exclusion List"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-end mb-4">
                    <Link to="/create-tourexclusions">
                      <Button color="primary">
                        <i className="ri-add-line align-middle me-1"></i> Add Tour Exclusion
                      </Button>
                    </Link>
                  </div>
                  <div className="table-responsive">
                    <Table className="table table-centered table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Tour Exclusion Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tourExclusions.length === 0 ? (
                          <tr>
                            <td colSpan="3" className="text-center">
                              No tour exclusions found.
                            </td>
                          </tr>
                        ) : (
                          tourExclusions.map((tourexclusion, index) => (
                            <tr key={tourexclusion._id || index}>
                              <td>{tourexclusion._id}</td>
                              <td>{tourexclusion.tourexclusion_name || 'N/A'}</td>
                              <td>
                                <button 
                                  className="tour-action-buttons me-2"
                                  onClick={() => handleEdit(tourexclusion)}
                                >
                                  <i className="ri-pencil-fill"></i>
                                </button>
                                <button 
                                  className="tour-action-buttons text-danger"
                                  onClick={() => handleDelete(tourexclusion._id)}
                                >
                                  <i className="ri-delete-bin-fill"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default TourExclusionList;
